<template>
  <div class="qaqc-dl-test-view">
    <DataQualityScorecardTable
      :rows="scorecardRows"
      :summary="scorecardSummary"
      dataset-label="DL Dataset"
    />
    <ValidationPassRateMatrixTable
      :rows="validationMatrixRows"
      :title="validationMatrixTitle"
      :description="validationMatrixDescription"
      matrix-test-context="dl"
    />
  </div>
</template>

<script>
import DataQualityScorecardTable from "./DataQualityScorecardTable.vue";
import ValidationPassRateMatrixTable from "./ValidationPassRateMatrixTable.vue";

export default {
  name: "DLTestView",
  components: {
    DataQualityScorecardTable,
    ValidationPassRateMatrixTable,
  },
  props: {
    scorecardRows: { type: Array, default: () => [] },
    scorecardSummary: {
      type: Object,
      default: () => ({
        overallPassRate: "0%",
        passedQc: 0,
        pendingQc: 0,
        failed: 0,
      }),
    },
    validationMatrixRows: { type: Array, default: () => [] },
    validationMatrixTitle: { type: String, default: "Validation Pass Rate Matrix" },
    validationMatrixDescription: { type: String, default: "Percentage of all DL samples passing each validation check" },
  },
};
</script>
